import { createContext, useContext, useState, useCallback } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";

const Ctx = createContext(null);

export function ComingSoonProvider({ children }) {
  const [state, setState] = useState({ open: false, title: "", note: "" });
  const show = useCallback((title, note) => setState({ open: true, title, note }), []);
  const close = () => setState((s) => ({ ...s, open: false }));

  return (
    <Ctx.Provider value={show}>
      {children}
      <Dialog open={state.open} onOpenChange={close}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <div className="h-10 w-10 rounded-lg bg-[#EDEFF7] grid place-items-center mb-2">
              <Sparkles size={18} className="text-[#011B90]" />
            </div>
            <DialogTitle className="font-display text-2xl">
              {state.title || "Coming soon"}
            </DialogTitle>
            <p data-testid="coming-soon-body" className="text-sm text-[#5F6677] pt-1">
              {state.note ||
                "This feature is coming soon. We're shipping it as part of the next QuoWin release."}
            </p>
          </DialogHeader>
          <DialogFooter>
            <Button
              data-testid="coming-soon-close"
              onClick={close}
              className="bg-[#011B90] hover:bg-[#011670] text-white"
            >
              Got it
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </Ctx.Provider>
  );
}

export function useComingSoon() {
  const ctx = useContext(Ctx);
  return ctx || (() => {});
}
